import ChargesView from './components/charges-view';

export default ChargesView;
